<!-- custom select button with image, no text -->
@if (showSelectButton() && selectButtonImage()) {
<button #openButton
    type="submit" [disabled]="disabled()"
    class="icon" [hisImage]="selectButtonImage()"
    [title]="selectButtonTooltip()" alt=""
    (click)="openOverlay(); $event.preventDefault();">
</button>
}
<!-- default select button -->
@if (showSelectButton() && !selectButtonImage()) {
<button #openButton
    type="submit" [disabled]="disabled()"
    class="transparent selectButton" hisImage="ARROW_RIGHT_FAT" alt=""
    (click)="openOverlay(); $event.preventDefault();">
    <span>{{(selectedOptions().length > 0) ? ('common.changeSelectedItems' | hisUi) : ('common.selectItems' | hisUi)}}</span>
</button>
}
@if (showDeleteButton() && selectedOptions().length > 0) {
<button type="submit" [disabled]="disabled()"
    class="transparent selectButton" hisImage="PANEL_CLOSE" alt=""
    (click)="unselectAll(); $event.preventDefault();">
    <span>{{'common.deleteSelectedItems' | hisUi}}</span>
</button>
}

@if (visible()) {
<p-dialog
    appendTo="body"
    showEffect="fade"
    [(visible)]="visible"
    [responsive]="true"
    [modal]="true"
    [blockScroll]="true"
    [focusTrap]="true"
    [header]="('multiselectPlam.selectValues' | hisUi) + ' ' + label()">
    <p-table
        [value]="filteredOptions()"
        [paginator]="true"
        [rows]="rowsPerPage()"
        [first]="firstResultRow()"
        [selectionPageOnly]="true"
        [(selection)]="selection"
        dataKey="id"
        (onPage)="onPage($event)"
        [customSort]="!!customSortFunction()"
        (sortFunction)="customSortFunction()($event)">
        <ng-template pTemplate="header">
            <tr>
                <th class="multiSelectColumn">
                    @let headerCheckboxTitle = headerCheckbox.checked
                        ? ('common.deselectAllOfPage' | hisUi)
                        : ('common.selectAllOfPage' | hisUi);
                    <p-tableHeaderCheckbox #headerCheckbox
                        class="hideOnBreakpointSmall"
                        [title]="headerCheckboxTitle"
                        [ariaLabel]="headerCheckboxTitle">
                    </p-tableHeaderCheckbox>
                    <span class="hideOnBreakpointLarge">{{'genericSearch.rowselect' | hisUi}}</span>
                </th>
                <th pSortableColumn="label">
                    {{label()}}
                    <p-sortIcon field="label"></p-sortIcon>
                    <div>
                        <input
                            [title]="'common.applyFilter' | hisUi"
                            pInputText type="text"
                            [(ngModel)]="filter"
                            (keydown.enter)="$event.stopPropagation(); applyFilter()"
                            (keydown.space)="$event.stopPropagation()"
                            (click)="$event.stopPropagation()" />
                    </div>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
            <tr>
                <td class="multiSelectColumn">
                    @let checkboxTitle = rowCheckbox.checked
                        ? ('common.deselectOf' | hisUi: row.label)
                        : ('common.selectOf' | hisUi: row.label);
                    <p-tableCheckbox #rowCheckbox [value]="row"
                        [title]="checkboxTitle"
                        [ariaLabel]="checkboxTitle">
                    </p-tableCheckbox>
                </td>
                <td>{{row.label}}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="paginatorright">
            <his-rows-per-page [resultRowsPerPage]="DEFAULT_ROWS_PER_PAGE"
                [rowsPerPage]="rowsPerPage()"
                [maxRows]="maxRows()"
                [totalRowCount]="totalRowCount()"
                [totalNumberOfPages]="totalNumberOfPages()"
                [currentPageNumber]="currentPageNumber()"
                (rowsPerPageChange)="onRowsPerPageChange($event)">
            </his-rows-per-page>
        </ng-template>
    </p-table>

    <ng-template #footer>
        <button type="submit" iconPos="left" hisImage="TICK" class="button_highlighted marginRightStandard"
            (click)="submitSelection(); $event.preventDefault();">
            <span style="vertical-align: middle">{{'common.applySelection' | hisUi}}</span>
        </button>
        <button type="submit" iconPos="left" hisImage="RED_X" class="button_highlighted blue"
            (click)="closeOverlay(); $event.preventDefault();">
            <span style="vertical-align: middle">{{'common.returnNoSelectionChange' | hisUi}}</span>
        </button>
    </ng-template>
</p-dialog>
}